import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import colors from '@/constants/Colors';
import { DrawerToggleButton } from "@react-navigation/drawer";
import Drawer from "expo-router/drawer";
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { AppVersionInfo } from '@/components/app-version-info';
import { UpdateChecker } from '@/components/update-checker';
import { NotificationStatus } from '@/components/notification-status';

export default function About() {
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <Drawer.Screen
        options={{
          drawerLabel: 'About',
          title: 'About',
          headerStyle: {
            backgroundColor: colors.primary,
          },
          headerTintColor: colors.accent,
          headerLeft: () => <DrawerToggleButton tintColor={colors.accent} />
        }}
      />

      <ScrollView style={styles.container}>
        <NotificationStatus />
        <AppVersionInfo />
        <UpdateChecker />
      </ScrollView>
    </GestureHandlerRootView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
    padding: 16,
  },
});

